import { LiquidProduct } from '@/features/product/types'

export const getVariantFromOptions = (
  options: string[],
  variants: LiquidProduct['variants'],
): LiquidProduct['variants'][number] | undefined =>
  variants.find((variant) =>
    variant.options.every((option, index) => option === options[index]),
  )
